import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/helpers/auth';

Vue.use(Router);

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

export default new Router({
	mode: 'history',
	duplicateNavigationPolicy: 'ignore',
	base: process.env.BASE_URL,
	routes: [{
		path: '/login',
		name: 'login',
		beforeEnter: isUnauth,
		component: () => import ('@/views/vo/auth/Login.vue'),
	},
	{
		path: '/sso/:token',
		name: 'sso',
		// beforeEnter: isUnauth,
		component: () => import ('@/views/vo/auth/LoginSSO.vue'),
	},
	{
		path: '/',
		component: () => import ('@/views/vo/layout/Main.vue'),
		children: [{
			path: '/',
			name: 'dashboard',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/dashboard/Dashboard.vue')
		},
		{
			path: '/profil/',
			name: 'profil',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/profil/profil/Profil.vue')
		},
		{
			path: '/ubah-password/',
			name: 'ubah-password',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/profil/ubahPassword/UbahPassword.vue')
		},
		{
			path: '/prospek-membership/',
			name: 'prospek-membership',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/prospekMembership/prospekMember.vue')
		},
		{
			path: '/genealogy/:network_code?',
			name: 'genealogy',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/genealogy/Genealogy.vue')
		},
		{
			path: '/prospek-mitra/',
			name: 'prospek-mitra',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/prospekMitra/ProspekMitra.vue')
		},
		{
			path: '/sponsor-pribadi/',
			name: 'Sponsor Pribadi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/sponsorPribadi/SponsorPribadi.vue')
		},
		{
			path: '/downline/',
			name: 'downline',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/downline/Downline.vue')
		},
		{
			path: '/pertumbuhan-jaringan/',
			name: 'pertumbuhan-jaringan',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/pertumbuhanJaringan/PertumbuhanJaringan.vue')
		},
		{
			path: '/registrasi-mitra/',
			name: 'registrasi-mitra',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/registrasi/Registration.vue')
		},
		{
			path: '/kloning-mitra/',
			name: 'kloning-mitra',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/registrasi/CloningMitra.vue')
		},
		{
			path: '/registrasi-pramitra/',
			name: 'registrasi-pramitra',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/registrasi/Registration.vue')
		},
		{
			path: '/aktivasi/',
			name: 'aktivasi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/registrasi/Activation.vue')
		},
		{
			path: '/aktivasi-mitra/',
			name: 'aktivasi-mitra',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/registrasi/ActivationMitra.vue')
		},
		{
			path: '/stock-produk/',
			name: 'produk',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/stockistArea/StockProduk.vue')
		},
		{
			path: '/belanja-produk-stockist/',
			name: 'belanja-produk-stockist',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/stockistArea/BelanjaProduk.vue')
		},
		{
			path: '/approval-transaksi/',
			name: 'approval-transaksi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/stockistArea/ApprovalTransaksi.vue')
		},
		{
			path: '/lap-belanja-produk-stockist/',
			name: 'lap-belanja-produk-stockist',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/stockistArea/LapBelanjaProduk.vue')
		},
		{
			path: '/transfer-serial-registrasi/',
			name: 'transfer-serial-registrasi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transferSerial/TransferSerialRegistrasi.vue')
		},
		{
			path: '/transfer-serial-binary/',
			name: 'transfer-serial-binary',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transferSerial/TransferSerialProdukBinary.vue')
		},
		{
			path: '/history-transfer-serial/',
			name: 'history-transfer-serial',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/historySerial/HistorySerial.vue')
		},
		{
			path: '/summary-komisi/',
			name: 'summary-komisi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/summaryKomisi/SummaryKomisi.vue')
		},
		{
			path: '/histori-komisi/',
			name: 'histori-komisi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/historiKomisi/HistoriKomisi.vue')
		},
		{
			path: '/histori-transfer/',
			name: 'histori-transfer',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/historiTransfer/HistoriTransfer.vue')
		},
		{
			path: '/history-transfer/:slug',
			name: 'bonus-statement',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/historiTransfer/components/BonusStatement.vue')
		},
		{
			path: '/stock-serial/',
			name: 'serial',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/serial/Serial.vue')
		},
		{
			path: '/list-stockist/',
			name: 'list-stockist',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/listStockist/ListStockist.vue')
		},
		{
			path: '/upgrade-kemitraan/',
			name: 'upgrade-kemitraan',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/upgradeKemitraan/UpgradeKemitraan.vue')
		},
		{
			path: '/tambah-ro/',
			name: 'tambah-ro',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/repeatOrder/tambahRO/TambahRO.vue')
		},
		{
			path: '/histori-ro/',
			name: 'histori-ro',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/repeatOrder/historiRO/HistoriRO.vue')
		},
		{
			path: '/omset-grup/',
			name: 'omset-grup',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/repeatOrder/omsetGrup/OmsetGrup.vue')
		},
		{
			path: '/belanja-produk/',
			name: 'belanja-produk',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/belanjaProduk/BelanjaProduk.vue')
		},
		{
			path: '/lap-pembelian-produk/',
			name: 'lap-pembelian-produk',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/lapPembelianProduk/LapPembelianProduk.vue')
		},
		{
			path: '/mutasi-saldo-belanja/',
			name: 'mutasi-saldo-belanja',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/mutasiSaldoBelanja/MutasiSaldoBelanja.vue')
		},
		{
			path: '/penukaran-serial/',
			name: 'penukaran-serial',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiSerial/penukaranSerial/PenukaranSerial.vue')
		},
		{
			path: '/lap-transaksi-serial/:type?',
			name: 'lap-transaksi-serial',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiSerial/lapTransaksiSerial/LapTransaksi.vue')
		},
		{
			path: '/transfer-saldo/',
			name: 'transfer-saldo',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/ewallet/transferEwallet/TransferEwallet.vue')
		},
		{
			path: '/histori-transfer-saldo/',
			name: 'histori-transfer-saldo',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/ewallet/historiTransfer/HistoriTransfer.vue')
		},
		{
			path: '/list-reward/',
			name: 'list-reward',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/reward/ListReward.vue')
		},
		{
			path: '/reward-saya/',
			name: 'reward-saya',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/reward/HistoryReward.vue')
		},
		{
			path: '/buat-pesan/:code?',
			name: 'buat-pesan',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/buatPesan/BuatPesan.vue')
		},
		{
			path: '/inbox/',
			name: 'inbox',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/inbox/Inbox.vue')
		},
		{
			path: '/detail-inbox/:id?',
			name: 'detail-inbox',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/inbox/components/DetailMessage.vue')
		},
		{
			path: '/pesan-terkirim/',
			name: 'pesan-terkirim',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/pesanTerkirim/PesanTerkirim.vue')
		},
		{
			path: '/detail-pesan-terkirim/:id?',
			name: 'detail-pesan-terkirim',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/pesanTerkirim/components/DetailMessage.vue')
		},
		{
			path: '/arsip/',
			name: 'arsip',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/arsip/Arsip.vue')
		},
		{
			path: '/detail-arsip/:id?',
			name: 'detail-arsip',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/arsip/components/DetailMessage.vue')
		},
		{
			path: '/berita/',
			name: 'berita',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/contentMitra/ListBerita.vue')
		},
		{
			path: '/pengumuman/',
			name: 'pengumuman',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/contentMitra/ListPengumuman.vue')
		},
		{
			path: '/testimoni/',
			name: 'testimoni',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/testimoni/Testimoni.vue')
		},]
	},
	{
		path: '*',
		component: () => import ('@/components/layout/vo/ErrorPage.vue'),
		children: [{
			path: '/maintenance',
			component: () => import ('@/views/Maintenance.vue')
		},
		{
			path: '*',
			name: 'not-found',
			component: () => import ('@/views/404.vue')
		}]
	}],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
});
